// 🔽 IMPORTS
import React, { useEffect, useState } from "react";
import axios from "../axiosInstance";
import { Sidebar } from "../components/Sidebar";
import { Header } from "../components/Header";
import { Footer } from "../components/ Footer";
import { Card } from "../components/ui/card";
import { Link } from "react-router-dom";
import { FaCrown } from "react-icons/fa";
import HighPerformanceAd from "../components/HighPerformanceAd";

export default function LeaderboardDrawPage({ onLogout }) {
  const [drawData, setDrawData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [lastUpdate, setLastUpdate] = useState(null);
  const [coinz, setCoinz] = useState(0);
  const [options, setOptions] = useState(0);
  const [weeklyProfit, setWeeklyProfit] = useState(0);
  const [username, setUsername] = useState(null);
  const [selfWeeklyProfit, setSelfWeeklyProfit] = useState(0) // Son propre bénéfice

  // 📡 RÉCUPÉRATION DES DONNÉES UTILISATEUR via l'API
  const getUserData = () => { 

    axios.get(`/api/user/me`, { withCredentials: true }) 
      .then((response) => {
        const { coinz, options, systemCoinz, weeklyProfit  } = response.data;
		    
       const valeurCalculee = options > 0 ? (( systemCoinz / weeklyProfit) * options) : 0;  // On évite la division par 0
		
		setSelfWeeklyProfit(valeurCalculee);
        setCoinz(coinz);
        setOptions(options);
        setWeeklyProfit(weeklyProfit);
        setLoading(false);
      })
      .catch((error) => {
        console.error("Erreur lors de la récupération des données:", error);
        setLoading(false);
      });
  };

  useEffect(() => {
    document.title = "Leaderboard | CoinzUp";
    getUserData();
    axios.get('/api/leaderboard/draw', { withCredentials: true })
      .then((res) => {
        console.log(res);
        setDrawData(res.data.leaderboard);
        setLastUpdate(res.data.lastUpdate);
        setLoading(false);
      })
      .catch((err) => {
        console.error("Failed to fetch leaderboard:", err);
        setLoading(false);
      });
  }, []);

  if (loading) return <div className="text-white p-10">Loading leaderboard...</div>;

  const getReward = (rank) => {
    if (rank === 1) return "15,000 Coinz 🥇";
    if (rank === 2) return "10,000 Coinz 🥈";
    if (rank === 3) return "7,500 Coinz 🥉";
    return "3,000 Coinz 💸";
  };

  return (
    <div className="min-h-screen flex flex-col bg-gray-900 text-gray-100">
      <div className="flex flex-1">
        <Sidebar onLogout={onLogout} />

        <main className="flex-1 px-6 py-10 space-y-8 overflow-auto">
        <Header 
          title="Leaderboard"  
          balance={coinz}        
          optionsOwned={options}        
          estimatedWeeklyGain={selfWeeklyProfit} 
        /> 

      <HighPerformanceAd
                keyId="fd5da3543c594f07b73630f461f10613"
                width={728}
                height={90}
              />

          {/* Introduction */}
          <Card className="p-6 bg-gray-800 border border-gray-700 rounded-2xl shadow-md text-sm text-gray-300">
            <p className="mb-2">
               <strong className="text-white">The more you draw, the higher you climb!</strong>
            </p>
            <p className="mb-1">
               The top 15 users with the most <Link to="/draw" className="underline text-blue-400 hover:text-blue-300">draws</Link> will be rewarded every <strong className="text-yellow-400">Sunday evening</strong>.
            </p>
            <p>
                <span className="text-green-400 font-medium">Top 3</span> receive massive prizes, while ranks 4–15 get <strong>3,000 Coinz</strong>!
                </p>
          </Card>

          {/* Leaderboard Table */}
          <div className="overflow-auto rounded-lg border border-gray-700 shadow-md">
            <table className="min-w-full text-sm text-left text-gray-300 bg-gray-800">
              <thead className="bg-gray-700 text-gray-100">
                <tr>
                  <th className="py-3 px-4">Rank</th>
                  <th className="py-3 px-4">User</th>
                  <th className="py-3 px-4">Draws</th>
                  <th className="py-3 px-4">Reward</th>
                </tr>
              </thead>
              <tbody>
                {drawData.map((user, index) => (
                  <tr key={user.username} className="hover:bg-gray-700 transition-all">
                    <td className="py-3 px-4 font-semibold text-white flex items-center gap-2">
                      {index < 3 && <FaCrown className={`text-yellow-${index === 0 ? "400" : index === 1 ? "300" : "200"}`} />}
                      {index + 1}
                    </td>
                    <td className="py-3 px-4">{user.username}</td>
                    <td className="py-3 px-4">{user.draws}</td>
                    <td className="py-3 px-4">{getReward(index + 1)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          {/* Last update */}
          <p className="text-xs text-gray-500 text-right mt-2 italic">
            Last update: {lastUpdate ? new Date(lastUpdate).toLocaleString() : "N/A"}
          </p>

          <HighPerformanceAd
          keyId="96e99453a24be0353f2fe26dc0b9b728"
          width={468}
          height={60}
        />

        </main>
      </div>

      <Footer />
    </div>
  );
}
